import React from 'react';
import { Navigate } from 'react-router-dom';
import { useIsMobile } from '../../hooks/useIsMobile';

/**
 * Route-level guard: screens outside the supported mobile scope redirect to
 * /projects on phones. Covers deep links and bookmarks — the drawer nav trim
 * only hides links, this makes the routes actually unreachable.
 *
 * Desktop renders children untouched.
 */
const MobileGate = ({ children }) => {
  const isMobile = useIsMobile();
  if (isMobile) {
    return <Navigate to='/projects' replace />;
  }
  return children;
};

export default MobileGate;
